module.exports = __webpack_public_path__ + "static/cnbc-img-f918fb5555bc3ca763254b28acece8fc.svg";